import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { TrendingUp, Download, DollarSign, Receipt, CreditCard, Tag, FileSpreadsheet, BarChart3, RefreshCw, RotateCcw, Shield, Mail, Zap, Layers } from "lucide-react";
import * as tests from "./testDefinitions";

export const FinancialsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Financials</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={TrendingUp}
          iconColor="text-green-600"
          title="Revenue"
          tests={tests.revenueTests}
          results={testResults.revenue}
        />
        
        <TestSubsection
          icon={BarChart3}
          iconColor="text-teal-600"
          title="Revenue Dashboard"
          tests={tests.revenueDashboardTests}
          results={testResults.revenueDashboard}
        />
        
        <TestSubsection
          icon={Download}
          iconColor="text-blue-600"
          title="Payouts"
          tests={tests.payoutsTests}
          results={testResults.payouts}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-emerald-600"
          title="Account"
          tests={tests.accountTests}
          results={testResults.account}
        />
        
        <TestSubsection
          icon={Receipt}
          iconColor="text-purple-600"
          title="Payroll"
          tests={tests.payrollTests}
          results={testResults.payroll}
        />
        
        <TestSubsection
          icon={FileSpreadsheet}
          iconColor="text-amber-600"
          title="Expenses"
          tests={tests.expensesTests}
          results={testResults.expenses}
        />
        
        <TestSubsection
          icon={Tag}
          iconColor="text-orange-600"
          title="Promo Codes"
          tests={tests.promoCodesTests}
          results={testResults.promoCodes}
        />
        
        <TestSubsection
          icon={CreditCard}
          iconColor="text-indigo-600"
          title="Stripe Connect / Payments"
          tests={tests.stripeConnectTests}
          results={testResults.stripeConnect}
        />
        
        <TestSubsection
          icon={RefreshCw}
          iconColor="text-cyan-600"
          title="Stripe Connect Sync (Tenant Isolation)"
          tests={tests.stripeConnectSyncTests}
          results={testResults.stripeConnectSync}
          endpoint="stripe-connect-sync"
        />
        
        <TestSubsection
          icon={RotateCcw}
          iconColor="text-orange-600"
          title="Refund System"
          tests={tests.refundSystemTests}
          results={testResults.refundSystem}
        />
        
        <TestSubsection
          icon={CreditCard}
          iconColor="text-red-600"
          title="Payment Security (CRITICAL)"
          tests={tests.paymentSecurityTests}
          results={testResults.paymentSecurity}
        />
        
        <TestSubsection
          icon={Zap}
          iconColor="text-yellow-600"
          title="Direct Charges (Stripe)"
          tests={tests.directChargesTests}
          results={testResults.directCharges}
          endpoint="direct-charges"
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-purple-600"
          title="Refund Security"
          tests={tests.refundSecurityTests}
          results={testResults.refundSecurity}
          endpoint="refund-security"
        />
        
        <TestSubsection
          icon={Layers}
          iconColor="text-blue-600"
          title="Multiple Refunds"
          tests={tests.multipleRefundsTests}
          results={testResults.multipleRefunds}
          endpoint="multiple-refunds"
        />
        
        <TestSubsection
          icon={Mail}
          iconColor="text-green-600"
          title="Email Notifications"
          tests={tests.emailNotificationsTests}
          results={testResults.emailNotifications}
          endpoint="email-notifications"
        />
      </CardContent>
    </Card>
  );
};
